/** Cookie key：onboarding 漏斗阶段（Proxy 门禁 + 客户端同步） */
export const EDGEN_ONBOARDING_STEP_COOKIE_KEY = "edgen_onboarding_step";

export type EdgenOnboardingStep = 1 | 2 | 3;

/** 解析 cookie 原始值；非法或空返回 null */
export function parseEdgenOnboardingStep(
  raw: string | undefined | null,
): EdgenOnboardingStep | null {
  if (raw === "1" || raw === "2" || raw === "3") {
    return Number(raw) as EdgenOnboardingStep;
  }
  return null;
}
